module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/135-belarus-3c3d8b11c9e250d403f0397f33a9a3bd.svg";